// extracted by mini-css-extract-plugin
export default {"segmentWrapper":"styles_segmentWrapper__I+IOt","segment":"styles_segment__nsLh0","calendarButton":"styles_calendarButton__X1HwQ","hiddenInput":"styles_hiddenInput__G0zE-"};